export const extensionRoutes = [  {
    path: 'extensions/reviews',
    loadChildren: () => import('./extensions/b15ad80f67a34bf792aa36bbcac6574368d7ba4fdcab107757422f7128532de7/routes'),
  }];
